module.exports = __webpack_public_path__ + "img/scope-art.c62f1a02.png";